import classNames from 'classnames';
import { FC } from 'react';

import Box, { BoxProps } from '../Box';

const size = 8;

const Jewel: FC<BoxProps> = boxProps => (
  <Box
    backgroundColor="jewel"
    borderRadius={size / 2}
    height={size}
    width={size}
    {...boxProps}
    className={classNames(boxProps.className, 'jewel')}
  />
);

export default Jewel;
